import * as isofetch from 'isomorphic-fetch';
import { StorageKey } from '../util/Storage';

export function customFetch(input: RequestInfo, init?: RequestInit): Promise<Response> {
    const cookies = document.cookie.split('; ').reduce((acc, cookie) => {
        const [key, value] = cookie.split('=');
        acc[key] = value;
        return acc;
    }, {});
    init = init || {};
    init = {
        ...init,
        credentials: 'include',
        headers: {
            ...init.headers,
            ...(cookies["X-Access-Token"] ? { "X-Access-Token": cookies["X-Access-Token"] } : {}),
        }
    };
    
    if (init.body && !(init.headers && init.headers['Content-Type'])) {
        init = {
            ...init,
            headers: {
                ...init.headers,
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        }
    }

    return isofetch(input, init).then((resp: Response) => {
        if (resp.ok) {
            localStorage.removeItem(StorageKey.ApiError);
            localStorage.removeItem(StorageKey.BackendFailure);
            let tokenExpirationString = resp.headers.get('Token-Expiration');
            if (tokenExpirationString) {
                localStorage.setItem(StorageKey.TokenExpiration, `${(+(tokenExpirationString as string) || 120) * 1000 + Date.now()}`);
            }
            return Promise.resolve(resp);
        }
        if (resp && resp.status === 401) {
            // Unauthorized, reset token
            localStorage.removeItem(StorageKey.Authenticated);
            localStorage.removeItem(StorageKey.TokenExpiration);
        }
        return Promise.reject(resp);
    }).catch((resp: Response) => {
        return Promise.reject(resp);
    });
}

export function processError(err?: any): Promise<any> {
    let resp = err as Response;
    let parsedError = undefined;
    if (typeof resp.json == 'function') {
        return resp.json().catch(() => {
            localStorage.setItem(StorageKey.BackendFailure, 'true');
            return Promise.reject(undefined);
        }).then(function (json) {
            localStorage.setItem(StorageKey.ApiError, JSON.stringify(json));
            return Promise.reject(json);
        });
    } else if (resp['response'] && resp['response'].data) {
        parsedError = resp['response'].data;
        localStorage.setItem(StorageKey.ApiError, JSON.stringify(parsedError));
    } else {
        localStorage.setItem(StorageKey.BackendFailure, 'true');
    }
    return Promise.reject(parsedError);
}